'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));

    if (SitePreferences.WISHLIST_ENABLED) {
        processInclude(require('./product/wishlist'));
    }

    if (SitePreferences.GIFTREGISTRY_ENABLED) {
        processInclude(require('ba-base/product/giftRegistry'));
    }
});

